import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space1, space6, space8 } = theme();

  return StyleSheet.create({
    bodyText: {
      marginBottom: space8,
    },
    modalContent: {
      paddingHorizontal: space6,
    },
    title: {
      marginBottom: space1,
      width: "100%",
    },
  });
};

export { style };
